import React from 'react'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import FormSelect from '@material-ui/core/Select'
import { makeStyles, FormHelperText } from '@material-ui/core'

const useStyles = makeStyles({
  width: {
    minWidth: '100%'
  }
})

export interface SelectProps {
  value: string;
  onChange: (value: string) => void;
  label: string;
  error?: boolean;
  options: string[];
  disabled?: boolean;
}

export const Select: React.FC<SelectProps> = function (props) {
  const { label, value, onChange, error = false, options = [], disabled = false } = props
  const styles = useStyles()

  return (
    <FormControl className={styles.width} disabled={disabled}>
      <InputLabel>{label}</InputLabel>
      <FormSelect value={value} onChange={e => onChange(e.target.value as string)} error={error}>
        {
          options.map(option => (
            <MenuItem value={option} key={option}>{option}</MenuItem>
          ))
        }
      </FormSelect>
      <FormHelperText>Proszę zaznaczyć jedną z opcji</FormHelperText>
    </FormControl>
  )
}